function initImageCarousel() {
    document.querySelectorAll('.image_carousel_swiper-js').forEach(function(swiperContainer) {
        new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                prevEl: swiperContainer.querySelector('.image_carousel_prev'),
                nextEl: swiperContainer.querySelector('.image_carousel_next'),
            },
        });
    });
};

document.addEventListener('DOMContentLoaded', function() {
    initImageCarousel();
});
